export { StarPrinterService } from './star-printer.service';
export { starPrintersServiceFactory } from './star-printer.service.factory';
